module.exports = __webpack_public_path__ + "assets/error-icon.c33555f8.svg";